import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    num: "01",
    id: "groom",
    title: "Groom Styling",
    desc: "Complete wedding looks for the dulha — sherwani, bandhgala, saafa, kalgi, jewellery and every royal detail in between.",
  },
  {
    num: "02",
    id: "family",
    title: "Family Styling",
    desc: "Coordinated palettes and outfits for the entire family, so the whole baraat looks like one beautiful story.",
  },
  {
    num: "03",
    id: "personal",
    title: "Personal Styling",
    desc: "Bespoke looks for cocktails, sangeet nights, festive evenings and your everyday signature wardrobe.",
  },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Services() {
  return (
    <section
      data-testid="services-section"
      className="border-b border-[#E5DEC9] bg-[#FDFBF7] py-24 text-[#141414] lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-16 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="text-xs font-semibold uppercase tracking-[0.35em] text-[#B38C43] lg:col-span-3"
          >
            What I Do
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:col-span-9 lg:text-5xl"
          >
            Three Kinds Of Styling —{" "}
            <span className="italic text-[#B38C43]">one royal standard.</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 gap-px bg-[#E5DEC9] md:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              onClick={() =>
                document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })
              }
              data-testid={`service-${s.id}`}
              className="group relative bg-[#FDFBF7] p-10 text-left transition-colors duration-500 hover:bg-[#F4EFE6] lg:p-12"
            >
              <span className="font-serif text-5xl font-light text-[#E5DEC9] transition-colors duration-500 group-hover:text-[#C5A059]">
                {s.num}
              </span>
              <h3 className="mt-6 flex items-center justify-between font-serif text-xl font-semibold sm:text-2xl">
                {s.title}
                <ArrowUpRight
                  size={20}
                  className="text-[#C5A059] opacity-0 transition-all duration-300 group-hover:translate-x-1 group-hover:opacity-100"
                />
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-[#686152] sm:text-base">
                {s.desc}
              </p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
